import { SearchBox } from '@g17eco/molecules/settings-sidebar';
import { FormFeedback, Input, Label } from 'reactstrap';
import { isValidDate } from '@features/stats/utils';
import { SelectFactory, SelectTypes, Option } from '@g17eco/molecules/select/SelectFactory';
import { TIMEZONE_OPTIONS, getDefaultTimezoneOption } from '@utils/timezone-options';
import './styles.scss';

type FormEventHandler = (e: React.FormEvent<HTMLInputElement>) => void;
type ChangeEventHandler = (e: React.ChangeEvent<HTMLInputElement>) => void;
interface SystemLogHeaderProps {
  searchText: string;
  fromDate?: string;
  toDate?: string;
  onSearchTextChange: FormEventHandler;
  onFromDateChange: ChangeEventHandler;
  onToDateChange: ChangeEventHandler;
  selectedTimezone: string;
  onTimezoneChange: (timezone: string) => void;
}

export const SystemLogHeader = ({
  searchText,
  fromDate,
  toDate,
  onSearchTextChange,
  onFromDateChange,
  onToDateChange,
  selectedTimezone,
  onTimezoneChange,
}: SystemLogHeaderProps) => {
  const selectedOption = TIMEZONE_OPTIONS.find((opt) => opt.value === selectedTimezone) ?? getDefaultTimezoneOption();

  const handleTimezoneChange = (option: Option<string> | null) => {
    if (option) {
      onTimezoneChange(option.value);
    }
  };

  return (
    <div className='system-log-header'>
      <div className='search-box'>
        <Label>Search logs: </Label>
        <SearchBox handleOnChange={onSearchTextChange} value={searchText} />
      </div>
      <div className='date-filter'>
        <div className='from-date'>
          <Label for='fromDate'>Between:</Label>
          <Input
            invalid={!isValidDate(fromDate)}
            value={fromDate ?? ''}
            name='fromDate'
            type='date'
            placeholder='dd/mm/yyyy'
            onChange={onFromDateChange}
          />
          <FormFeedback tooltip>Please input a data with format is dd/mm/yyyy</FormFeedback>
        </div>
        <div className='to-date'>
          <Label for='toDate'>-</Label>
          <Input
            invalid={!isValidDate(toDate)}
            value={toDate ?? ''}
            name='toDate'
            type='date'
            placeholder='dd/mm/yyyy'
            onChange={onToDateChange}
          />
          <FormFeedback tooltip>Please input a data with format is dd/mm/yyyy</FormFeedback>
        </div>
        <div className='timezone-select'>
          <SelectFactory
            selectType={SelectTypes.SingleSelect}
            options={TIMEZONE_OPTIONS}
            value={selectedOption}
            onChange={handleTimezoneChange}
            minWidth={420}
            isMenuPortalTargetBody
          />
        </div>
      </div>
    </div>
  );
};
